import { Box } from '@mui/material';
import LineClampTypography from 'src/components/common/ui/LineClampTypography';
import { FlexColumnContainer } from 'src/components/styles';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import ProductList from 'src/features/products/presentation/components/ProductList';
import { useBrandProducts } from 'src/features/products/presentation/hooks/useBrandProducts';
import ProductGridSkeleton from 'src/features/products/presentation/components/ProductGridSkeleton';
import RequestHandler from 'src/components/RequestHandler/RequestHandler';

export const ProductsScreen = () => {
  const { isXs, isMobile } = useAppUI();
  const { brandProducts, isLoading, isError, refetch } = useBrandProducts({
    brandSlug: 'terea',
  });

  return (
    <FlexColumnContainer p={1} gap={3} width="100%">
      <LineClampTypography
        content="Productos Disponibles"
        lines={1}
        typographyProps={{
          variant: isMobile ? 'h4' : 'h2',
          color: '#000',
          fontWeight: 'bold',
          textTransform: 'capitalize',
          py: 1,
        }}
        disableFulltextToggle
      />
      <Box px={0.6} width="100%">
        <RequestHandler
          isLoading={isLoading}
          isError={isError}
          data={brandProducts?.results}
          refetch={refetch}
          skeleton={<ProductGridSkeleton />}
          errorProps={{
            title: 'No pudimos cargar los productos',
            subtitle:
              'Hubo un problema al cargar los productos. Por favor, intenta nuevamente.',
            buttonText: 'Reintentar',
          }}
          emptyStateProps={{
            title: 'No hay productos disponibles',
            subtitle:
              'En este momento no pudimos encontrar productos disponibles.',
            buttonText: 'Actualizar',
            onButtonClick: refetch,
          }}
        >
          {(products) => (
            <ProductList
              productCardProps={{
                height: { xs: '180px', sm: '225px', md: '250px' },
                maxTitleLines: isXs ? 2 : undefined,
              }}
              products={products}
            />
          )}
        </RequestHandler>
      </Box>
    </FlexColumnContainer>
  );
};
